import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                <span>Custom Software</span> Development Company
              </h1>
              <p>
                Grow your global presence with the leading US-based custom software development company. To help you achieve your goals, we embrace diverse programming languages, platforms, and cutting-edge tech.
              </p>
              <p>Partner with us to turn challenges into success! Our skilled software developers specialize in empowering small to medium businesses, delivering up to 65% ROI.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../images/services-usa/custom/banner-img.webp"
              alt="Custom Software Development Company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={755}
              height={422}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
